;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import Link from 'next/link';
import { MdChevronRight } from 'react-icons/md';
import capitalizeFirstLetter from '../../../utils/capitalizeFirstLetter';
import NotificationItem from './NotificationItem';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';
import { useParams } from 'next/navigation';

type Props = {
  dictionary: Partial<Dictionaries>;
  notifications: MySynergieNotification[];
};

const DashboardNotifications = ({ notifications, dictionary }: Props): JSX.Element => {
  const { formatMessage } = getI18nUtils(dictionary);
  const { locale } = useParams();
  return (
    <section className="mysynergie-dashboard-notifications">
      <div className="d-flex justify-content-between align-items-center mb-3 mb-md-3">
        <h2 className="mb-0">{capitalizeFirstLetter(formatMessage({ id: 'mysynergie_notifications' }))}</h2>
        {notifications?.length > 0 && (
          <Link href={`/${locale}/my-synergie/notifications`} className="d-block d-md-none">
            {capitalizeFirstLetter(formatMessage({ id: 'mysynergie_notifications_view_all' }))}
            <MdChevronRight size={16} className="ms-2" />
          </Link>
        )}
      </div>
      {notifications?.length > 0 && (
        <div>
          {notifications.map((notification, index) => (
            <NotificationItem dictionary={dictionary} notification={notification} key={`notification-${index}`} />
          ))}
          <Link
            href={`/${locale}/my-synergie/notifications`}
            className="button button-mysynergie-secondary d-none d-md-flex align-items-center justify-content-center p-2 w-100"
          >
            {capitalizeFirstLetter(formatMessage({ id: 'mysynergie_notifications_view_all' }))}
            <span>
              <MdChevronRight size={16} className="ms-2" />
            </span>
          </Link>
        </div>
      )}
      {notifications?.length === 0 && (
        <div className="my-5 pt-md-5 d-flex justify-content-center align-items-center">
          <h3 className="text-center">{formatMessage({ id: 'no_notifications' })}</h3>
        </div>
      )}
    </section>
  );
};

export default DashboardNotifications;
